
let url = '';
if (process.env.MIX_APP_ENV === 'production') {
    if (process.env.MIX_FACULTY_LABEL === 'FTSP') {
        url = '/kp';
    } else if (process.env.MIX_FACULTY_LABEL === 'FTI') {
        url = '/v2';
    }
} else if (process.env.MIX_APP_ENV === 'staging') {
    if (process.env.MIX_FACULTY_LABEL === 'FTSP') {
        url = '/kp-staging';
    } else if (process.env.MIX_FACULTY_LABEL === 'FTI') {
        url = '/v2-staging';
    }
}
export const globalBaseUrl = url;

export const unduh = {
    lembarKonsultasi() {
        return url + '/api/unduh/lembar-konsultasi';
    },
    lembarKegiatan() {
        return url + '/api/unduh/lembar-kegiatan';
    },
    lembarPenilaianPembimbing() {
        return url + '/api/unduh/lembar-penilaian-pembimbing';
    },
};